import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Button
} from '@material-ui/core';

const styles = makeStyles({
	button: {
		color: 'rgba(0, 0, 0, 0.54)',
		fontSize: '0.8rem',
		marginLeft: -8
	},

	buttonContainer: {
		textAlign: 'center'
	}
});

function LoginHelpButton(props) {
	const classes = styles();
	let {children, centered, handleClick} = props;

	return (
		<div className={(centered) ? classes.buttonContainer : null}>
			<Button className={classes.button} onClick={handleClick} size="small" variant="text">
				{children}
			</Button>
		</div>
	);
}

LoginHelpButton.propTypes = {
	centered: PropTypes.bool,
	handleClick: PropTypes.func,
	children: PropTypes.string
};

export default LoginHelpButton;